import useAppStore from 'store/useAppStore';

const checkViewFileType = (type) => {
  switch (type) {
    case 'application/pdf':
      return 'pdf';
    case 'image/png':
    case 'image/jpg':
    case 'image/jpeg':
    case 'image/gif':
      return 'image';
    default:
      useAppStore.getState().showNotification('此檔案類型不支援預覽', 'info');
      return false;
  }
};
export default checkViewFileType;
